import {mapMutations} from 'vuex';
import {
    SET_LOADING,
    UNSET_LOADING
} from '@/store/mutation-types';

export const loadingMixin = {
    methods: {
        ...mapMutations({
            '$_loadingMixin_showLoading': SET_LOADING,
            '$_loadingMixin_hideLoading': UNSET_LOADING,
        })
    }
};